import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const MaintenancePage = lazy(() => import('../pages/MaintenancePage'));
const MaintenancePageReminders = lazy(() => import('../pages/MaintenancePageReminders'));
const MaintenancePageHistory = lazy(() => import('../pages/MaintenancePageHistory'));
const MaintenanceDashboardPage = lazy(() => import('../pages/MaintenanceDashboardPage'));

export interface IRoute {
  path: string;
  team?: string;
  component: any;
  accessDeniedDescription: string;
  routes?: IRoute[];
  exact?: boolean;
}

const routes: IRoute[] = [
  {
    path: Location.MAINTENANCE,
    team: 'squad-gf-core',
    component: MaintenancePage,
    accessDeniedDescription: 'ver informações de manutenção de veículos',
    routes: [
      {
        path: Location.MAINTENANCE_REMINDERS,
        component: MaintenancePageReminders,
        accessDeniedDescription: 'Lembretes de manutenções',
        exact: true,
      },
      {
        path: Location.MAINTENANCE_DASHBOARD,
        component: MaintenanceDashboardPage,
        accessDeniedDescription: 'Análises',
        exact: true,
      },
      {
        path: Location.MAINTENANCE_HISTORY,
        component: MaintenancePageHistory,
        accessDeniedDescription: 'Histórico de manutenções',
        exact: true,
      },
    ],
  },
];

export default routes;
